import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor() { }
  encryptText(plainText: string) {
    const key = CryptoJS.enc.Utf8.parse(environment.PasswordEncryptionKey.trim());
    const iv = CryptoJS.enc.Utf8.parse(environment.PasswordEncryptionKey.trim());

    return CryptoJS.AES.encrypt(
      plainText.trim(),
      key,
      {
        keySize: 32,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
  }
}
